import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function StrategicRegulatoryPlanning() {
  const pillars = [
    {
      title: 'Alignment of Business Goals with Regulatory Authority Requirements',
      description:
        'Ensuring strategic harmony between company ambitions and compliance frameworks.',
    },
    {
      title: 'Navigating the Regulatory Compliance Landscape',
      description:
        'Proactively managing evolving standards and jurisdictional nuances.',
    },
    {
      title: 'Leveraging Regulatory Exclusivity',
      description:
        'Maximizing competitive advantage through strategic exclusivity planning.',
    },
    {
      title: 'Harnessing Regulatory Intelligence',
      description:
        'Utilizing data-driven insights to anticipate trends and mitigate risks.',
    },
    {
      title: 'Designing Global Submission Strategies',
      description:
        'Streamlining documentation and timelines for multi-market approvals.',
    },
    {
      title: 'Optimising Approval Pathways',
      description:
        'Selecting the most efficient route to market based on product type, geography, and business goals.',
    },
  ];

  return (
    <div className="font-sans">
      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Strategic Regulatory Planning']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300"></span>
          <h3 className="text-lg font-semibold text-[#05326D]">
            Strategic Regulatory Planning
          </h3>
        </div>


        <h4 className="text-md font-semibold text-[#05326D] mb-1">
          The Cornerstone of Market Success
        </h4>

        <p className="mb-4 text-[#05326D]">
          At FDAC, we recognize that a well-defined and timely regulatory strategy is essential for successful market
          entry and long-term business growth. In today’s competitive landscape, especially within complex and diverse
          markets such as the European Union, navigating regulatory pathways requires precision, foresight, and deep
          expertise.
        </p>
        <p className="mb-8 text-[#05326D]">
          Selecting the optimal procedure—be it Centralized (CP), Mutual Recognition (MRP), Decentralized (DCP), or
          National—can significantly impact approval timelines and commercial outcomes. With extensive experience in
          securing successful regulatory approvals across global markets, Nuvo empowers clients with tailored strategies
          that align with both business objectives and regulatory expectations.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Our approach to regulatory strategy is built on six critical pillars:
        </h2>

        <div className="space-y-6">
          {pillars.map((pillar, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="mt-1 w-2 h-2 rounded-full bg-sky-300 flex-shrink-0" />
              <div>
                <h4 className="text-md font-semibold text-[#05326D]">{pillar.title}</h4>
                <p className="text-[#05326D]">{pillar.description}</p>
              </div>
            </div>
          ))}
        </div>

        <hr className="border-t border-gray-300 my-10" />

        <p className="text-sm text-[#05326D]">
          At FDAC, we don’t just manage regulatory processes—we architect success. Our commitment is to deliver regulatory
          strategies that are not only compliant but commercially impactful, enabling our clients to unlock market potential
          with confidence and speed.
        </p>
      </div>
    </div>
  );
}

export default StrategicRegulatoryPlanning;